var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-treeview',{staticClass:"property-tree",attrs:{"dense":"","items":_vm.mappedProperties,"open":_vm.expandedProperties,"open-on-click":""},on:{"update:open":function($event){_vm.expandedProperties=$event}},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var item = ref.item;
return [_c('PropertyTreeNode',{attrs:{"item":item}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }